const utilities = {
  objectToParams(object) {
    const searchParams = new URLSearchParams()
    Object.entries(object).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          searchParams.append(key, val)
        })
      } else {
        searchParams.set(key, value)
      }
    })
    return searchParams.toString()
  },
  paramsToObject(string) {
    if (string.charAt(0) == "?") string = string.slice(1)
    const search = String(string).split("&")

    const params = search.reduce((acc, param) => {
      const [key, value] = param.split("=")
      if (!value) return acc

      if (!acc[key]) {
        acc[key] = value
      } else {
        if (!Array.isArray(acc[key])) acc[key] = [acc[key]]
        acc[key].push(value)
      }

      return acc
    }, {})

    return params
  },
  updateUrlParams(object) {
    const queryObject = this.paramsToObject(window.location.search)
    const newObject = {
      ...queryObject,
      ...object,
    }
    const newString = this.objectToParams(newObject)

    window.history.pushState({}, "", `?${newString}`)

    return newString
  },
}

window.utilities = utilities

export default utilities
